import axios from '../../axios';
import * as TYPES from '../types';

const state = {
  balanceSheets: [],
  balanceSheetDetail: null
};
const getters = {
  balanceSheets: state => state.balanceSheets,
  balanceSheetDetail: state => state.balanceSheetDetail,
};
const mutations = {
  [TYPES.SET_BALANCE_SHEETS](state, payload) {
    state.balanceSheets = payload;
  },
  [TYPES.SET_BALANCE_SHEET_DETAIL](state, payload) {
    state.balanceSheetDetail = payload;
  }
};
const actions = {
  /**
   * 获取资产负债表
   * @param commit
   */
  getBalanceSheets: ({commit}) => {
    commit(TYPES.SET_LOADING, true);
    axios
      .get("/balance-sheets",{params:{sort:'companyId,desc'}})
      .then(response => {
        commit(TYPES.SET_BALANCE_SHEETS, response.data.data);
        commit(TYPES.SET_LOADING, false);
      })
      .catch(reason => {
        commit(TYPES.SET_ERROR, reason.message);
        commit(TYPES.SET_LOADING, false);
      });
  },

  /**
   * 获取资产负债表详情
   * @param commit
   * @param balanceSheetId
   */
  getBalanceSheetDetail: ({commit}, balanceSheetId) => {
    commit(TYPES.SET_BALANCE_SHEET_DETAIL, null);
    commit(TYPES.SET_LOADING, true);
    axios
      .get("/balance-sheets/" + balanceSheetId)
      .then(response => {
        commit(TYPES.SET_BALANCE_SHEET_DETAIL, response.data);
        commit(TYPES.SET_LOADING, false);
      })
      .catch(reason => {
        commit(TYPES.SET_ERROR, reason.message);
        commit(TYPES.SET_LOADING, false);
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions
}